import { __rest } from "tslib";
import styled from '@emotion/styled';
import React from 'react';
import { theme } from '../../../theme';
import { useField } from 'formik';
import { getErrorIconStyles, getErrorStyles } from './styles';
import ChevronDown from '../../../assets/chevron-down.svg';
const StyledLabel = styled.label `
	display: flex;
	flex-direction: column;
	margin-bottom: 1rem;
	width: 100%;
	padding: 0.25rem 0;
	position: relative;
`;
const StyledTitle = styled.span `
	${theme.typography.IR90};
	color: ${theme.colors.LM_NU100};
	height: 1.125rem;
	line-height: 125%;
	margin-bottom: 0.25rem;
	user-select: none;
`;
const StyledDescription = styled.span `
	${theme.typography.IR90};
	color: rgba(17, 34, 58, 0.65);
	font-size: 0.875rem;
	line-height: 150%;
	margin-bottom: 0.5rem;
`;
const StyledSelect = styled.select `
	appearance: none;
	outline-offset: -2px;

	${theme.typography.IR100};
	line-height: 150%;

	width: 100%;
	padding: 0.625rem 0.75rem 0.625rem 1rem;
	position: relative;

	border: solid 1px;
	border-radius: ${theme.radii.radii30};
	border-color: ${theme.colors.LM_NU30};

	color: #11233a;
	background-color: ${theme.colors.LM_NU10};

	:hover {
		background-color: ${theme.colors.LM_NU20};
	}

	:active {
		outline: 2px solid ${theme.colors.BB100};
		background-color: ${theme.colors.LM_NU20};
	}
	:focus {
		outline: 2px solid ${theme.colors.BB80};
		background-color: ${theme.colors.LM_NU20};
	}

	${({ error, touched }) => (Object.assign({}, getErrorStyles(error, touched)))};
`;
const StyledErrorMsg = styled.span `
	${theme.typography.IR90};
	color: ${theme.colors.NE100};
	padding: 0.5rem 0;
`;
const StyledErrorIcon = styled.span `
	position: relative;
	display: inherit;
	width: 100%;

	${({ error, touched }) => ({
    ':after': Object.assign({}, getErrorIconStyles(error, touched)),
})};
`;
const StyledChevronIcon = styled.span `
	position: relative;
	display: inherit;
	width: auto;

	:after {
		content: url("${ChevronDown}");
		position: absolute;
		display: block;
		width: 11.5px;
		height: 6.5px;
		right: 26px;
		top: 12px;
		pointer-events: none;
	}
`;
// Internal InputField component
export const SelectField = (props) => {
    const { label, options, placeholder } = props;
    // Formik connector
    const [field, meta] = useField(props);
    const { touched, error, value } = meta;
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledChevronIcon, null,
            React.createElement(StyledErrorIcon, { touched: touched, error: error },
                React.createElement(StyledSelect, Object.assign({ "data-testid": "input", "aria-label": props['aria-label'] || label }, field, meta, props, { value: value || '' }),
                    placeholder && (React.createElement("option", { label: placeholder, disabled: true, value: "" }, placeholder)),
                    options.map((o, idx) => (React.createElement("option", Object.assign({ key: idx }, o), o.label)))))),
        touched && error && React.createElement(StyledErrorMsg, null, error)));
};
// Enhanced with Label & Description
export const Select = (_a) => {
    var { label, description, style, className } = _a, otherProps = __rest(_a, ["label", "description", "style", "className"]);
    return (React.createElement(StyledLabel, { className: className, style: style },
        label && React.createElement(StyledTitle, null, label),
        description && (React.createElement(StyledDescription, null, description)),
        React.createElement(SelectField, Object.assign({ label: label }, otherProps))));
};
//# sourceMappingURL=Select.js.map